import React, { useState, useEffect, useRef } from "react";
// import DeleteIcon from "@mui/icons-material/Delete";
import AddTaskIcon from "@mui/icons-material/AddTask";
import { NotInterested } from "@mui/icons-material";
import * as Mui from "@mui/material";
import { checkFirstLevelApproverPermission } from "services/utils/HelperFunction";
import {
  themes,
  scrollTop,
  optionalAvathar,
  tableRowSx,
} from "services/constants";
import { useFetch } from "services/hooks/useFetch";
import { useSelector } from "react-redux";
import { Loader } from "components/Loader";
import { showToast } from "services/utils/Status";
import { DialogBox } from "../DialogBox";
import sessionHandling from "services/utils/notificationUtils";
import { tooltipStyleProps } from "services/constants/Styles";
import {
  InfoMessage,
  CustomButton,
} from "components/CustomComponents/CustomButton";
let multiApiCallRestriction = true;
const keys = [
  "status",
  "user_name",
  "amount",
  "repayment_date",
  "advance_type",
  "description",
  "reason",
];
export const Approve = ({
  departmentId,
  departmentChange,
  setDepartmentChange,
  overTimeScreen,
}) => {
  const {
    domain,
    token,
    userDetails,
    globalSearchValue,
    userScreenAccess,
    topbarCompanyId,
  } = useSelector((state) => state.tokenReducer);
  const [page, setPage] = useState(0);
  const [rejectReason, setRejectReason] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [rejectedReasonValidation, setRejectedReasonValidation] = useState("");
  const [openRejectDialog, setOpenRejectDialog] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [advanceSalary, setAdvanceSalary] = useState([]);
  const [updateData, setUpdateData] = useState(true);
  const [buttonLoader, setButtonLoader] = useState(false);
  const containerRef = useRef(null);
  const {
    result: advanceDetails,
    setLoad: reCallApi,
    loading,
  } = useFetch(
    `${domain}advances/?user_id=${userDetails.id}&status=Pending&department_id=${departmentId}&company_id=${topbarCompanyId}`
  );

  useEffect(() => {
    if (topbarCompanyId) {
      reCallApi(true);
    }
  }, [reCallApi, topbarCompanyId]);

  useEffect(() => {
    if (departmentChange && overTimeScreen === "Approve") {
      reCallApi(true);
      setDepartmentChange(false);
    }
  }, [departmentChange, overTimeScreen, reCallApi, setDepartmentChange]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleDeleteCancel = () => {
    setRejectReason("");
    setOpenRejectDialog(false);
    setRejectedReasonValidation("");
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  const onSubmit = async () => {
    if (rejectReason.trim() === "") {
      setRejectedReasonValidation("Reason");
      return;
    } else if (rejectReason.length < 5) {
      setRejectedReasonValidation("Less than 5 character");
      return;
    }

    try {
      await handleReject();
      setOpenRejectDialog(false);
      setRejectedReasonValidation("");
    } catch (error) {
      showToast("error", error.message);
    }
  };

  const handleApprove = async (item) => {
    if (multiApiCallRestriction) {
      setButtonLoader(true);
      multiApiCallRestriction = false;
      try {
        const response = await fetch(`${domain}advances/${item.id}/approve/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        });
        const res = await response.json();
        if (response.ok) {
          showToast("success", res.status);
          multiApiCallRestriction = true;
          reCallApi(true);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
        multiApiCallRestriction = true;
      } finally {
        setButtonLoader(false);
      }
    }
  };

  const handleReject = async () => {
    if (!selectedItem) return;
    setButtonLoader(true);
    try {
      const response = await fetch(
        `${domain}advances/${selectedItem.id}/reject/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
          body: JSON.stringify({
            reason: rejectReason,
          }),
        }
      );
      const res = await response.json();
      if (response.ok) {
        showToast("error", res.status);
        reCallApi(true);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
    } catch (error) {
      showToast("error", error.message);
    } finally {
      setButtonLoader(false);
    }
  };

  useEffect(() => {
    if (updateData && advanceDetails?.length !== 0 && advanceDetails) {
      setAdvanceSalary(advanceDetails);
      setUpdateData(false);
    }
  }, [advanceDetails, updateData]);

  useEffect(() => {
    if (advanceDetails?.length !== 0 || advanceDetails?.length === 0) {
      const filteredResults = advanceDetails?.filter((item) =>
        keys.some((key) =>
          item[key]
            ?.toString()
            .toLowerCase()
            .includes(globalSearchValue.toString().toLowerCase())
        )
      );
      setAdvanceSalary(filteredResults);
      setPage(globalSearchValue ? 0 : page);
    }
  }, [advanceDetails, globalSearchValue, page]);

  return loading ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      <Mui.Grid container>
        <Mui.TableContainer
          ref={containerRef}
          sx={{ width: "100%", maxHeight: 724, mt: 2, ml: 2, mr: 2 }}
        >
          <Mui.Table className="border">
            <Mui.TableHead
              sx={{
                backgroundColor: themes.primary,
                position: "sticky",
                top: -1,
                zIndex: 10,
              }}
            >
              <Mui.TableRow sx={tableRowSx}>
                <Mui.TableCell>
                  <Mui.Typography fontWeight="bold">
                    Employee Name
                  </Mui.Typography>
                </Mui.TableCell>
                <Mui.TableCell>
                  <Mui.Typography fontWeight="bold">Date</Mui.Typography>
                </Mui.TableCell>
                <Mui.TableCell>
                  <Mui.Typography fontWeight="bold">
                    Advance Amount
                  </Mui.Typography>
                </Mui.TableCell>
                <Mui.TableCell>
                  <Mui.Typography fontWeight="bold">
                    Advance Type
                  </Mui.Typography>
                </Mui.TableCell>
                <Mui.TableCell>
                  <Mui.Typography fontWeight="bold">Description</Mui.Typography>
                </Mui.TableCell>
                <Mui.TableCell>
                  <Mui.Typography
                    fontWeight="bold"
                    sx={{ textAlign: "center" }}
                  >
                    Actions
                  </Mui.Typography>
                </Mui.TableCell>
              </Mui.TableRow>
            </Mui.TableHead>

            <Mui.TableBody>
              {advanceSalary?.length === 0 ? (
                <InfoMessage dataLength={advanceDetails} />
              ) : (
                advanceSalary
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item) => (
                    <Mui.TableRow sx={tableRowSx}>
                      <Mui.TableCell>
                        <Mui.Stack direction="Row">
                          <Mui.Avatar
                            sx={{ width: 23, height: 23 }}
                            alt={item?.user_name?.charAt(0).toUpperCase()}
                            src={item?.image_url ?? optionalAvathar}
                          />
                          &nbsp;
                          {item?.user_name}
                        </Mui.Stack>
                      </Mui.TableCell>
                      <Mui.TableCell>{item?.repayment_date}</Mui.TableCell>
                      <Mui.TableCell>{item?.amount}</Mui.TableCell>
                      <Mui.TableCell>{item?.advance_type}</Mui.TableCell>
                      <Mui.TableCell>{item?.description}</Mui.TableCell>
                      <Mui.TableCell sx={{ textAlign: "center" }}>
                        <Mui.Tooltip
                          arrow
                          slotProps={tooltipStyleProps}
                          title="Approve"
                        >
                          <Mui.IconButton
                            onClick={() => {
                              if (
                                checkFirstLevelApproverPermission(
                                  userScreenAccess?.module_details,
                                  "Approve",
                                  "Advance Salary"
                                )
                              ) {
                                handleApprove(item);
                              } else {
                                showToast(
                                  "error",
                                  "Access denied: You are not authorized to approve the advance salary"
                                );
                              }
                            }}
                          >
                            <AddTaskIcon
                              sx={{
                                color: themes.primaryIndicator,
                                strokeWidth: 2,
                              }}
                            />
                          </Mui.IconButton>
                        </Mui.Tooltip>
                        <Mui.Tooltip
                          arrow
                          slotProps={tooltipStyleProps}
                          title="Reject"
                        >
                          <Mui.IconButton
                            onClick={() => {
                              if (
                                checkFirstLevelApproverPermission(
                                  userScreenAccess?.module_details,
                                  "Approve",
                                  "Advance Salary"
                                )
                              ) {
                                setOpenRejectDialog(true);
                                setSelectedItem(item);
                              } else {
                                showToast(
                                  "error",
                                  "Access denied: You are not authorized to reject the advance salary"
                                );
                              }
                            }}
                          >
                            <NotInterested
                              sx={{
                                color: themes.redColor,
                                strokeWidth: 2,
                              }}
                            />
                          </Mui.IconButton>
                        </Mui.Tooltip>
                      </Mui.TableCell>
                    </Mui.TableRow>
                  ))
              )}
            </Mui.TableBody>
          </Mui.Table>
        </Mui.TableContainer>
      </Mui.Grid>

      {advanceSalary.length > 25 && (
        <Mui.TablePagination
          className="custom-pagination"
          rowsPerPageOptions={[25, 50, 75, 100]}
          component="div"
          count={advanceSalary.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}

      <DialogBox
        open={openRejectDialog}
        onClose={handleDeleteCancel}
        title="Reason for Rejection"
      >
        <Mui.TextField
          multiline
          minRows={3}
          sx={{
            marginTop: 1,
            width: "95%",
            marginLeft: 2,
            marginRight: "auto",
          }}
          placeholder="please enter reason of rejection"
          onChange={(e) => setRejectReason(e.target.value)}
        />
        {rejectedReasonValidation === "Reason" ? (
          <Mui.Typography
            variant="body2"
            color="error"
            sx={{ fontSize: 13, paddingLeft: 3, paddingTop: 0.5 }}
          >
            Please enter the rejected reason
          </Mui.Typography>
        ) : null}
        {rejectedReasonValidation === "Less than 5 character" ? (
          <Mui.Typography
            variant="body2"
            color="error"
            sx={{ fontSize: 13, paddingLeft: 3, paddingTop: 0.5 }}
          >
            Minium 5 character required
          </Mui.Typography>
        ) : null}

        <Mui.Grid container sx={{ paddingTop: 1 }}>
          <Mui.Grid xs={8}></Mui.Grid>
          <Mui.Grid
            xs={4}
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              paddingRight: 1,
            }}
          >
            <CustomButton
              actionFuntion={handleDeleteCancel}
              actionName="Cancel"
              typeName="button"
            />
            &nbsp;&nbsp;
            <CustomButton
              actionFuntion={onSubmit}
              actionName="Reject"
              disableAction={buttonLoader}
              typeName="submit"
            />
          </Mui.Grid>
        </Mui.Grid>
      </DialogBox>
    </React.Fragment>
  );
};
